
/**
 * Role of user in meeting for schedule
 */
export const UserRole = {
    admin: "admin",
    speaker: "speaker",
    member: "member",
    empty: ""
} as const;

export type UserRole = typeof UserRole[keyof typeof UserRole];